import { components, inputModes, services } from '@/utils'

function renderServerField(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.ServerId,
        label: this.getTranslate(`${services.providers}.labels.server`),
        service: services.servers,
        mode: inputModes.outline,
        rounded: true,
        dense: true,
        details: false,
        clearable: true,
        autocomplete: true
      },
      on: {
        input: event => {
          this.proxy.ServerId = event
        }
      }
    }
  )
}
function renderCredentialsField(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.CredentialsId,
        label: this.getTranslate(`${services.providers}.labels.credentials`),
        service: services.credentials,
        mode: inputModes.outline,
        rounded: true,
        dense: true,
        details: false,
        clearable: true,
        autocomplete: true
      },
      on: {
        input: event => {
          this.proxy.CredentialsId = event
        }
      }
    }
  )
}

function renderIsActiveField(h) {
  return h(
    components.switch,
    {
      props: {
        label: this.getTranslate(`filter.isActive.${this.proxy.isActive}`),
        value: this.proxy.isActive,
        outline: true
      },
      on: {
        input: event => {
          this.proxy.isActive = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${services.providers}-filter`
    },
    [
      renderServerField.call(this, h),
      renderCredentialsField.call(this, h),
      renderIsActiveField.call(this, h)
    ]
  )
}
